import { TxpObject } from 'txp-data';

/**
 *  Returns ewsId present in txpEntity if EmailReminder else returns itemId
 */
export default function getItemIdForReportIssue(txpObject: TxpObject, itemId: string): string {
    let txpEntities = txpObject && txpObject.txpEntities;
    if (txpEntities) {
        let ewsIds: string[] = Object.values(txpEntities).map(entity => entity.originalEmailEwsId);
        return ewsIds[0] || itemId;
    } else {
        return itemId;
    }
}
